var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1329 10.1833C10.1079 10.1833 10.0912 10.1833 10.0662 10.1833C10.0246 10.175 9.96623 10.175 9.91623 10.1833C7.49956 10.1083 5.67456 8.20829 5.67456 5.86663C5.67456 3.48329 7.61623 1.54163 9.99956 1.54163C12.3829 1.54163 14.3246 3.48329 14.3246 5.86663C14.3162 8.20829 12.4829 10.1083 10.1579 10.1833C10.1496 10.1833 10.1412 10.1833 10.1329 10.1833ZM9.99956 2.79163C8.30789 2.79163 6.92456 4.17496 6.92456 5.86663C6.92456 7.53329 8.22456 8.87496 9.88289 8.93329C9.92456 8.92496 10.0412 8.92496 10.1496 8.93329C11.7829 8.85829 13.0662 7.51663 13.0746 5.86663C13.0746 4.17496 11.6912 2.79163 9.99956 2.79163Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1413 19.2917C8.50801 19.2917 6.86634 18.875 5.62467 18.0417C4.46634 17.275 3.83301 16.225 3.83301 15.0834C3.83301 13.9417 4.46634 12.8834 5.62467 12.1084C8.12467 10.45 12.1747 10.45 14.658 12.1084C15.808 12.875 16.4497 13.925 16.4497 15.0667C16.4497 16.2084 15.8163 17.2667 14.658 18.0417C13.408 18.875 11.7747 19.2917 10.1413 19.2917ZM6.31634 13.1584C5.51634 13.6917 5.08301 14.375 5.08301 15.0917C5.08301 15.8 5.52467 16.4834 6.31634 17.0084C8.39134 18.4 11.8913 18.4 13.9663 17.0084C14.7663 16.475 15.1997 15.7917 15.1997 15.075C15.1997 14.3667 14.758 13.6834 13.9663 13.1584C11.8913 11.775 8.39134 11.775 6.31634 13.1584Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/ManagerIcon.3f789d4cac3c26e4c2875d274ae6b8b2.svg";
export { ForwardRef as ReactComponent };